import Main from './classes/Main'

new Main()
